
const ORDERS_STAFF_LOAD = 'ORDERS_STAFF_LOAD';
const ORDERS_CHAIN_LOAD = 'ORDERS_CHAIN_LOAD';

const ORDERS_LOAD = 'ORDERS_LOAD';
const ORDERS_LOAD_SUCCESS = 'ORDERS_LOAD_SUCCESS';
const ORDERS_LOAD_FAIL = 'ORDERS_LOAD_FAIL';

const ORDERS_PENDING_LOAD = 'ORDERS_PENDING_LOAD';
const ORDERS_PENDING_LOAD_SUCCESS = 'ORDERS_PENDING_LOAD_SUCCESS';
const ORDERS_PENDING_LOAD_FAIL = 'ORDERS_PENDING_LOAD_FAIL';

const ORDERS_UPDATES_LOAD = 'ORDERS_UPDATES_LOAD';
const ORDERS_UPDATES_LOAD_SUCCESS = 'ORDERS_UPDATES_LOAD_SUCCESS';
const ORDERS_UPDATES_LOAD_FAIL = 'ORDERS_UPDATES_LOAD_FAIL';

const ORDERS_CLEAR_PENDING = 'ORDERS_CLEAR_PENDING';
const ORDERS_CLEAR_UPDATES = 'ORDERS_CLEAR_UPDATES';
const ORDERS_CHANGE_TYPE = 'ORDERS_CHANGE_TYPE';
const ORDERS_CHANGE_ATTR = 'ORDERS_CHANGE_ATTR';

const ORDER_SHOW_ORDER = 'ORDER_SHOW_ORDER';
const ORDER_SHOW_ORDER_UPDATES = 'ORDER_SHOW_ORDER_UPDATES';
const ORDER_CLOSE_ORDER = 'ORDER_CLOSE_ORDER';
const ORDER_REMOVE_PENDING = 'ORDER_REMOVE_PENDING';
const ORDER_REMOVE_UPDATES = 'ORDER_REMOVE_UPDATES';

const ORDER_LOAD_DETAILS = 'ORDER_LOAD_DETAILS';
const ORDER_LOAD_DETAILS_SUCCESS = 'ORDER_LOAD_DETAILS_SUCCESS';
const ORDER_LOAD_DETAILS_FAIL = 'ORDER_LOAD_DETAILS_FAIL';

const ORDER_ACTION_CLICK = 'ORDER_ACTION_CLICK'
const ORDER_ACTION_CLICK_SUCCESS = 'ORDER_ACTION_CLICK_SUCCESS'
const ORDER_ACTION_CLICK_FAIL = 'ORDER_ACTION_CLICK_FAIL'

const APP_ALLOW_SOUND = 'APP_ALLOW_SOUND'
const ORDERS_UPDATE_ONLY_FOOD = 'ORDERS_UPDATE_ONLY_FOOD'

const ORDER_VISIBLE_REFUND_REASON = 'ORDER_VISIBLE_REFUND_REASON'
const ORDER_UPDATE_REFUND_REASON = 'ORDER_UPDATE_REFUND_REASON'
const ORDER_UPDATE_REFUND_REASON_TEXT = 'ORDER_UPDATE_REFUND_REASON_TEXT'
const ORDER_UPDATE_REFUND_REASON_AMOUNT = 'ORDER_UPDATE_REFUND_REASON_AMOUNT'

const ORDER_REMOVE_PENDING_BY_ORDER_ID = 'ORDER_REMOVE_PENDING_BY_ORDER_ID'

export const onOrderRemovePendingByOrderId = (orderId) => ({type: ORDER_REMOVE_PENDING_BY_ORDER_ID, orderId })
export const onAppAllowSound = (orderId) => ({type: APP_ALLOW_SOUND, orderId })
export const onOrderVisibleRefundReason = (show) => ({type: ORDER_VISIBLE_REFUND_REASON, show })
export const onOrderUpdateRefundReason = (reason) => ({type: ORDER_UPDATE_REFUND_REASON, reason })
export const onOrderUpdateRefundReasonText = (text) => ({type: ORDER_UPDATE_REFUND_REASON_TEXT, text })
export const onOrderUpdateRefundReasonAmount = (amount) => ({type: ORDER_UPDATE_REFUND_REASON_AMOUNT, amount })

export const onOrderLoadDetails = (orderId) => ({type: ORDER_LOAD_DETAILS, orderId })
export const onOrderLoadDetailsSuccess = (data) => ({type: ORDER_LOAD_DETAILS_SUCCESS, data })
export const onOrderLoadDetailsFail = (e) => ({type: ORDER_LOAD_DETAILS_FAIL, e })

export const onOrdersLoad = (filters = {}) => ({type: ORDERS_LOAD, filters })
export const onChainOrdersLoad = (filters = {}) => ({type: ORDERS_CHAIN_LOAD, filters })
export const onStaffOrdersLoad = (page) => ({type: ORDERS_STAFF_LOAD, page })
export const onOrdersLoadSuccess = (data) => ({type: ORDERS_LOAD_SUCCESS, data })
export const onOrdersLoadFail = () => ({type: ORDERS_LOAD_FAIL })

export const onOrdersPendingLoad = (order, event) => ({type: ORDERS_PENDING_LOAD, order, event })
export const onOrdersPendingLoadSuccess = () => ({type: ORDERS_PENDING_LOAD_SUCCESS })
export const onOrdersPendingLoadFail = () => ({type: ORDERS_PENDING_LOAD_FAIL })

export const onOrdersUpdatesLoad = (order, event) => ({type: ORDERS_UPDATES_LOAD, order, event })
export const onOrdersUpdatesLoadSuccess = () => ({type: ORDERS_UPDATES_LOAD_SUCCESS })
export const onOrdersUpdatesLoadFail = () => ({type: ORDERS_UPDATES_LOAD_FAIL })

export const onOrdersClearPending = () => ({type: ORDERS_CLEAR_PENDING })
export const onOrdersClearUpdates = () => ({type: ORDERS_CLEAR_UPDATES })

export const onOrdersChangeType = (value) => ({type: ORDERS_CHANGE_TYPE, value })
export const onOrdersUpdateAttribute = (name, value) => ({type: ORDERS_CHANGE_ATTR, name, value })

export const onOrdersShowOrder = (order, index) => ({type: ORDER_SHOW_ORDER, order, index })
export const onOrdersShowOrderUpdates = (order, index) => ({type: ORDER_SHOW_ORDER_UPDATES, order, index })
export const onOrdersCloseOrder = () => ({type: ORDER_CLOSE_ORDER })
export const onOrdersRemovePending = (index) => ({type: ORDER_REMOVE_PENDING, index })
export const onOrdersRemoveUpdates = (index) => ({type: ORDER_REMOVE_UPDATES, index })

export const onOrderActionClick = (orderId, action) => ({type: ORDER_ACTION_CLICK, orderId, action })
export const onOrderActionClickSuccess = (data) => ({type: ORDER_ACTION_CLICK_SUCCESS, data })
export const onOrderActionClickFail = (e) => ({type: ORDER_ACTION_CLICK_FAIL, e })

export const onUpdateOnlyFood = (e) => ({type: ORDERS_UPDATE_ONLY_FOOD, e })
